import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    TibboDataType,
    SettingControlType,
    CodeBlock,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';

const LCD_SCREEN_WIDGET_COLUMNS = 128;
const LCD_SCREEN_WIDGET_ROWS = 64;

export default class BaseDisplayPeripheral extends BasePeripheral {
    constructor() {
        super();

        const settings: Array<Setting> = [
            {
                id: 'GENERAL',
                name: 'General',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'IMAGES_GROUP',
                name: 'Images',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'ADVANCED',
                name: 'Advanced',
                settingType: SettingType.GROUP,
                default: '',
            },
            {
                id: 'ROTATION',
                name: 'Rotation',
                settingType: SettingType.OPTION,
                group: 'GENERAL',
                required: true,
                default: '0',
                options: [
                    {
                        name: '0',
                        value: '0',
                    },
                    {
                        name: '90',
                        value: '90',
                    },
                    {
                        name: '180',
                        value: '180',
                    },
                    {
                        name: '270',
                        value: '270',
                    },
                ],
            },
            {
                id: 'WIDGETS',
                name: 'LCD Widgets',
                settingType: SettingType.HIDDEN,
                required: true,
                group: 'GENERAL',
                controlType: SettingControlType.WIDGETS,
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'SCREENS',
                name: 'Screens',
                settingType: SettingType.ARRAY,
                required: true,
                group: 'GENERAL',
                refId: 'display_screen',
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'IMAGES',
                name: 'Images',
                settingType: SettingType.ARRAY,
                refId: 'lcd_image',
                required: true,
                group: 'IMAGES_GROUP',
                default: new Array<BaseFeature>(0),
            },
            {
                id: 'LCD_SCREEN_WIDGET_COLUMNS',
                name: 'Width',
                group: 'GENERAL',
                settingType: SettingType.NUMBER,
                required: true,
                default: LCD_SCREEN_WIDGET_COLUMNS.toString(),
            },
            {
                id: 'LCD_SCREEN_WIDGET_ROWS',
                name: 'Height',
                group: 'GENERAL',
                settingType: SettingType.NUMBER,
                required: true,
                default: LCD_SCREEN_WIDGET_ROWS.toString(),
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies(): string[] {
        return [
            'display_lib',
        ];
    }


    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/ssi_i2c';
    }
}
